export default {
  "1001": "10",
  "1002": "",
  "1003": "20",
  "1004": "",
  "1005": "",
  "1006": "21",
  "1007": "22",
  "1008": "",
  "1009": "",
  "1010": "23",
  "1012": "",
  "1013": "",
  "1014": "",
  "1015": "",
  "1016": "",
  "1017": "",
  "1018": "",
  "1019": "25",
  "1020": "",
  "1021": "",
  "1022": "",
}